<template>
  <v-card flat>
    <v-radio-group
      v-model="valueComputed"
      :mandatory="$route.name !== 'qr.id.edit'"
      class="ma-0"
      hide-details
      row
    >
      <v-radio
        v-for="(item, i) in components"
        :key="i"
        :value="item.name"
        class="ms-md-8 mb-4"
      >
        <template v-slot:label>
          <v-img
            :src="frames.find((obj) => obj.name === item.name).src"
            class="ms-2"
            contain
            height="100"
            width="50"
          />
        </template>
      </v-radio>
    </v-radio-group>
  </v-card>
</template>

<script>
export default {
  name: "themeSelector",

  props: {
    value: String,
    components: Array,
    framePics: Array,
  },

  data: () => ({
    frames: [
      { name: "MobileViwer", src: "/media/frame/themes/1.svg" },
      { name: "VisitThemeTwo", src: "/media/frame/themes/2.svg" },
      { name: "VisitThemeFlipped", src: "/media/frame/themes/3.svg" },
    ],
  }),

  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped>
.v-input >>> .v-label {
  margin: 0;
}

.v-input >>> .v-input--selection-controls__input {
  align-self: flex-start;
}
</style>
